<template>
  <div class="lazy-users">
    <mainmenu selected="report_lazy_users"></mainmenu>
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-6">
          <h1>{{$t('report_lazy_users.page_title')}}</h1>
        </div>
        <div class="col-md-6 text-right">
          <a class="btn btn-success" href="https://textiles-market.com/api/index.php/Report_lazy_users/export_inactive_users_list">{{$t('report_lazy_users.inactive_users_export_to_excel')}}</a> | 
          <a class="btn btn-success" href="https://textiles-market.com/api/index.php/Report_lazy_users/export_non_responding_sellers">{{$t('report_lazy_users.not_responding_users_export_to_excel')}}</a>
        </div>
      </div>
      

        <el-card>
            <h2>{{$t('report_lazy_users.inactive_users')}}</h2>
            <el-table :data="InactiveUsers" style="width: 100%; margin-top: 50px" v-if="InactiveUsers.length>0" >
                <el-table-column :label="$t('report_lazy_users.user')" >
                    <template slot-scope="scope">
                        <strong>{{scope.row.Name}}</strong>
                    </template>
                </el-table-column>

                <el-table-column :label="$t('report_lazy_users.factory')"  >
                    <template slot-scope="scope">
                        {{scope.row.FactoryShortCode}}
                    </template>
                </el-table-column>


                <el-table-column :label="$t('report_lazy_users.last_update')"  width="150" >
                    <template slot-scope="scope">
                        <span v-if="scope.row.DaysSinceLastUpdate != '-1'">
                            {{scope.row.DaysSinceLastUpdate}} {{$t('report_lazy_users.days')}}
                        </span>
                        <span v-else>
                            {{$t('report_lazy_users.never')}}
                        </span>
                    </template>
                </el-table-column>


                <el-table-column :label="$t('report_lazy_users.days_since_last_login')" width="180" fixed="right" >
                    <template slot-scope="scope">
                        {{scope.row.Days}} {{$t('report_lazy_users.days')}}
                    </template>
                </el-table-column>

            </el-table>
            <div v-else>
                {{$t('report_lazy_users.all_users_are_ok')}}
            </div>

            <h2>{{ $t('report_lazy_users.not_responding_users') }}</h2>
            

            <el-table :data="NotRespondingUsers" style="width: 100%; margin-top: 50px" v-if="NotRespondingUsers.length>0" >
              <el-table-column :label="$t('report_lazy_users.user')" prop="Name"></el-table-column>
              <el-table-column :label="$t('report_lazy_users.factory')" prop="FactoryShortCode"></el-table-column>
              <el-table-column :label="$t('report_lazy_users.buyer')" prop="BuyerName"></el-table-column>
              <el-table-column :label="$t('report_lazy_users.buyer_factory')" prop="BuyerShortCode"></el-table-column>
              <el-table-column :label="$t('report_lazy_users.days_since_request')">
                 <template slot-scope="scope">
                    {{scope.row.Days}} {{$t('report_lazy_users.days')}}
                  </template>
              </el-table-column>
            </el-table>
            <div v-else>
                {{$t('report_lazy_users.all_users_are_ok')}}
            </div>
        </el-card>
    </div>
  </div>
</template>

<script>
import MainMenu from "./../../widgets/MainMenu";
import settings from "./../../backend/LocalSettings";

export default {
  name: "report_lazy_users",
  components: {
    "mainmenu": MainMenu
  },
  data () {
    return { 
      tableLoadingVisible: false,
      InactiveUsers: [],
      NotRespondingUsers: []
    }
  },
  methods: {
    
    refresh_info: function() {
      this.loadingVisible = true;
      this.$http
          .post('report_lazy_users/refresh_info',  {  } )
          .then(function (response) {
            this.tableLoadingVisible = false;
            if( settings.verify_response(response, this.$rights)) {
              this.InactiveUsers        = response.body.InactiveUsers;
              this.NotRespondingUsers   = response.body.NotRespondingUsers;
            } else {
              this.$router.push("/");
            }
          }); 
    }
  },
  mounted: function() {
    this.refresh_info();
  }
};
</script>

<style lang="less" scoped>
  .button-link{
    text-decoration: none;
  }
</style>